import { NavLink, Outlet } from 'react-router-dom';
import { TicketCheck } from 'lucide-react';
import { UiIcon } from '../components/ui-icon';
import { useI18n } from '../i18n/i18n-provider';

export function AttendeeLayout() {
  const { t } = useI18n();
  return <section className="attendee-workspace" data-surface="attendee">
    <div className="attendee-workspace__content"><Outlet /></div>
    <nav className="attendee-nav" aria-label={t('nav.attendee')}>
      <NavLink to="/attendee" end><UiIcon name="spark" />{t('nav.overview')}</NavLink>
      <NavLink to="/attendee/events"><UiIcon name="calendar" />{t('nav.events')}</NavLink>
      <NavLink to="/attendee/enrollments"><TicketCheck aria-hidden="true" />{t('nav.enrollments')}</NavLink>
      <NavLink to="/attendee/tasks"><UiIcon name="check" />{t('nav.tasks')}</NavLink>
    </nav>
  </section>;
}
